/* eslint-disable react-hooks/exhaustive-deps */
"use client"

import { useState, useEffect } from "react"
import { Container, Row, Col } from "react-bootstrap"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"
import "bootstrap/dist/css/bootstrap.min.css"
import { cashFlowItemsResumeByDimension, cashFlowItemsResumeByProject, cashFlowPCGDimensionResume, cashFlowPCGResume, getProjetsByCompanyRequest, resetCashFlowGeneral, resetCashFlowPCGItemsReset, resetProjetsByCompanyRequest } from "../../actions/cash-flow.action"
import { useDispatch } from "react-redux"
import BudgetChart from "./BudgetChart"
import InputsGroup from "./InputsGroup"
import ChartAndTable from "./ChartAndTable"


ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend)

const CashFlowPC = () => {
	const dispatch = useDispatch();

  const [selectedCoin, setSelectedCoin] = useState("PEN")
  const [selectedCompany, setSelectedCompany] = useState("")
  const [mode, setMode] = useState("-1")
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)

  const [period, setPeriod] = useState("0")
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedStructure, setSelectedStructure] = useState('');
  const [selectedRow, setSelectedRow] = useState('');

  useEffect(() => {
    if (!endDate) {
      return
    }
    setSelectedProject('')
    dispatch(resetProjetsByCompanyRequest())
    getProjetsByCompanyRequest(selectedCompany, startDate, endDate);
  }, [selectedCompany, startDate, endDate])

  useEffect(() => {
    if (!selectedStructure || !endDate) {
      return;
    }
    dispatch(resetCashFlowPCGItemsReset())
    if (mode === '-1') {
      cashFlowItemsResumeByProject(endDate, selectedStructure, selectedCompany, selectedProject)
    } else {
      cashFlowItemsResumeByDimension(endDate, selectedStructure, mode, selectedCompany, selectedProject)
    }
  }, [endDate, selectedCompany, mode, selectedProject, selectedStructure])

  useEffect(() => {
    if (!selectedStructure || !endDate) {
      return;
    }
    dispatch(resetCashFlowGeneral())
    if (mode === '-1') {
      cashFlowPCGResume(startDate, endDate, selectedCompany, selectedProject, period, selectedStructure, selectedRow) 
    } else {
      cashFlowPCGDimensionResume(startDate, endDate, selectedCompany, period, selectedStructure, selectedRow, mode, selectedProject)
    }
  }, [selectedCompany, startDate, endDate, period, selectedProject, selectedStructure, selectedRow, mode])

  return (
    <Container fluid className="p-3" style={{height: '90%'}}>
        <InputsGroup
          selectedCoin={selectedCoin}
          setSelectedCoin={setSelectedCoin}
          selectedCompany={selectedCompany}
          setSelectedCompany={setSelectedCompany}
          mode={mode}
          setMode={setMode}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          period={period}
          setPeriod={setPeriod}
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
        />


      <Row style={{height: '100%'}}>
        <Col md={4} style={{height: '90%', marginTop: '3em'}}>
          <BudgetChart 
            title='Partida de Control General'
            selectedCoin={selectedCoin}
            selectedStructure={selectedStructure}
            setSelectedStructure={setSelectedStructure}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            requiresStructure={true}
          />
        </Col>
        <Col md={8} style={{height: '100%', maxHeight: '100%'}}>
          <ChartAndTable 
            startDate={startDate}
            endDate={endDate}
            selectedCoin={selectedCoin}
            selectedItem={selectedRow}
          />
        </Col>

      </Row>
    </Container>
  )
}

export default CashFlowPC
